{
  "name": "graphics-2026-israel-election-poll-tracker",
  "version": "2.11.8",
  "type": "module",
  "private": true,
  "scripts": {
    "start": "vite dev --open",
    "stories:sync": "npx rngs-io stories sync",
    "preview": "npm-run-all publish:preview stories:autolink publish:git-commit",
    "upload": "npx graphics-publisher upload",
    "upload:quick": "npx graphics-publisher upload:quick",
    "pub": "npm-run-all publish:publish stories:autolink publish:git-commit",
    "build": "vite build",
    "build:preview": "PREVIEW=true vite build",
    "diagnose": "npx graphics-publisher diagnose",
    "mods": "tsx ./bin/mods/index.ts mods",
    "savile": "savile row ./src/statics/images",
    "stories:unconfig": "tsx ./bin/mods/index.ts unconfig-rngs-io",
    "stories:new": "npx rngs-io stories new --template",
    "stories:connect": "npx rngs-io stories connect",
    "stories:autolink": "npx rngs-io stories autolink --name page-en",
    "stories:live": "npx rngs-io stories live preview",
    "get-google": "npx graphics google:get-docs google.json",
    "lock-google": "npx graphics google:lock-docs google.json",
    "publish:preview": "npx graphics-publisher preview",
    "publish:publish": "npx graphics-publisher publish",
    "publish:git-commit": "npx graphics github:push",
    "startup:check-creds": "npx graphics dotfile:check",
    "startup:create-repo": "npx graphics github:create-repo",
    "startup": "npm-run-all startup:*",
    "test": "vitest",
    "check": "svelte-kit sync && svelte-check --tsconfig ./tsconfig.json",
    "lint": "eslint --fix .",
    "format": "prettier . --write",
    "knip": "knip",
    "sync-llms": "node bin/sync-llms/index.js",
    "test:skills": "vitest run --config .claude/skills/vitest.config.ts"
  },
  "devDependencies": {
    "@anthropic-ai/claude-agent-sdk": "^0.3.206",
    "@clack/prompts": "^0.10.1",
    "@evilmartians/lefthook": "^1.13.6",
    "@reuters-graphics/clack": "^0.0.2",
    "@reuters-graphics/graphics-bin": "^1.1.10",
    "@reuters-graphics/graphics-kit-publisher": "^3.5.1",
    "@reuters-graphics/illustrator-exports": "^0.0.2",
    "@reuters-graphics/rngs-io-client": "^0.1.12",
    "@reuters-graphics/savile": "^0.2.0",
    "@reuters-graphics/vite-plugin-purge-styles": "^0.0.5",
    "@reuters-graphics/yaks-eslint": "^0.1.1",
    "@reuters-graphics/yaks-prettier": "^0.1.1",
    "@sindresorhus/slugify": "^2.2.1",
    "@sveltejs/adapter-static": "^3.0.10",
    "@sveltejs/kit": "^2.69.2",
    "@sveltejs/vite-plugin-svelte": "^7.2.0",
    "@types/fs-extra": "^11.0.4",
    "@types/language-tags": "^1.0.4",
    "@types/lodash.throttle": "^4.1.9",
    "@types/mock-fs": "^4.13.4",
    "autoprefixer": "^10.5.2",
    "cheerio": "^1.2.0",
    "dedent": "^1.7.2",
    "empathic": "^1.1.0",
    "eslint": "^9.39.4",
    "fs-extra": "^11.3.6",
    "glob": "^11.1.0",
    "ignore": "^7.0.5",
    "knip": "^5.88.1",
    "magic-string": "^0.30.21",
    "mock-fs": "^5.5.0",
    "npm-run-all": "^4.1.5",
    "picocolors": "^1.1.1",
    "postcss": "^8.5.16",
    "prettier": "^3.9.5",
    "prettier-plugin-svelte": "^4.1.1",
    "rimraf": "^6.1.3",
    "sade": "^1.8.1",
    "sass": "^1.101.0",
    "sharp": "^0.34.5",
    "svelte": "^5.56.4",
    "svelte-check": "^4.7.2",
    "svelte-preprocess": "^6.0.5",
    "tsx": "^4.23.0",
    "typescript": "^5.9.3",
    "vite": "^8.1.4",
    "vitest": "^4.1.10"
  },
  "engines": {
    "node": ">=22"
  },
  "dependencies": {
    "@reuters-graphics/graphics-components": "4.10.2",
    "d3-array": "^3.2.4",
    "d3-axis": "^3.0.0",
    "d3-format": "^3.1.2",
    "d3-regression": "^2.2.0",
    "d3-scale": "^4.0.2",
    "d3-selection": "^3.0.0",
    "d3-shape": "^3.2.0",
    "d3-time-format": "^4.1.0",
    "handlebars": "^4.7.9",
    "language-tags": "^1.0.9",
    "lodash.throttle": "^4.1.1",
    "slugify": "^1.6.9",
    "textures": "^1.2.3"
  },
  "reuters": {
    "graphic": {
      "desk": "london",
      "slugs": {
        "root": "ISRAEL-ELECTION",
        "wild": "POLLS"
      },
      "language": "en",
      "title": "The latest polls ahead of Israel’s October election",
      "description": "Graphic",
      "authors": [
        {
          "name": "Adrian Blanco Ramos",
          "link": "https://www.reuters.com/authors/adrian-blanco-ramos/"
        },
        {
          "name": "Maayan Lubell",
          "link": "https://www.reuters.com/authors/maayan-lubell/"
        }
      ],
      "contactEmail": "adrian.blanco@thomsonreuters.com",
      "pack": "86842d40-b7f5-4113-a840-ccd840ce2a19",
      "archives": {
        "media-en-page": {
          "title": "Netanyahu bloc trails rivals in polls ahead of Israel's October 27 election",
          "description": "Israel heads to the polls in a closely watched election that could determine whether Prime Minister Benjamin Netanyahu remains in power.",
          "url": "https://www.reuters.com/graphics/ISRAEL-ELECTION/POLLS/egpbgkzqmvq/",
          "uploaded": "2026-10-14T10:41:12.453Z",
          "editions": [
            "interactive",
            "media-interactive"
          ]
        },
        "public": {
          "url": "https://www.reuters.com/graphics/ISRAEL-ELECTION/POLLS/lgvdbwrakvo/",
          "uploaded": "2026-10-14T10:40:37.607Z",
          "editions": [
            "interactive"
          ]
        }
      },
      "published": "2026-09-16T12:02:43.267Z",
      "updated": "2026-10-14T10:45:26.374Z"
    },
    "preview": "https://graphics.thomsonreuters.com/testfiles/2026/EjEQq9Lxgj/",
    "separateAssets": "https://graphics.thomsonreuters.com/client-files/pack-assets/86842d40-b7f5-4113-a840-ccd840ce2a19/assets.zip"
  },
  "homepage": "https://www.reuters.com/graphics/ISRAEL-ELECTION/POLLS/lgvdbwrakvo/"
}